module.exports = __webpack_public_path__ + "img/39.b0fc1dc2.png";